import { ENDPOINT_ROOT } from '@/common/constants';
import axiosAuth from '@/common/interceptors/axios.AuthInterceptor';

const dataFormatter = (data) =>
  Object.keys(data)
    .filter((itemKey) => data[itemKey].length > 0)
    .map((itemKey) => ({
      key: itemKey,
      items: [...data[itemKey]],
    }));

const getSearchAutocomplete = ({ queryKey: [endpoint, term] }) => {
  const params = {
    completion_term: term.toLowerCase(),
  };

  return axiosAuth
    .get(`${ENDPOINT_ROOT}/${endpoint}`, { params })
    .then((res) => dataFormatter(res.data));
};

export default getSearchAutocomplete;
